import { CoeMyWork } from "src/models/coeMyWork";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeMyWorkEntityModel = createEntityModel<CoeMyWork>();
